import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button, Form, Input, message } from 'antd'
import { AuthContext } from '../Context/AuthContext';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useFetch } from '../../services/ApiService';

function OTPForm() {

  const loginFormRef = useRef();
  const [btnLoading, setBtnLoading] = useState(false);
  const auth = useContext(AuthContext);
  const { fetchApi } = useFetch();
  const [email, setEmail] = useState(null);

  const handleLogin = async (values) => {
    setBtnLoading(true);

    
    
    const payload = {
      email,
      otp: values.otp
    }

    await fetchApi('/api/verify_login_otp', 'POST', payload).then(res => {
      //console.log(res.accessToken);
      if (res.accessToken) {
        sessionStorage.setItem("User_Token", res.accessToken);
        auth.updateUserToken();
        navigate('/')
      }
      if(res.message){
        message.success(res.message)
      }
    }).catch(err => {
      if(err.data.data.message.data.error){
        message.error(err.data.data.message.data.error)
      }
    }).finally(() => {
      setBtnLoading(false);
    })
  }

  const navigate = useNavigate()
  let [searchParams, setSearchParams] = useSearchParams();


  useEffect(() => {
    const emailParams = searchParams.get('email');
    if(emailParams){
      setEmail(emailParams)
    }
    else{
      navigate('/')
    }
  }, [searchParams])
  

  return (
    <>
      <div className='login-title'>
        <h1 className='mb-1'>Verify OTP</h1>
        <p className='small'>OTP has been sent to <strong>{email}</strong>. Please verify your email to complete login.</p>
      </div>
      <Form
        name="login-form"
        ref={loginFormRef}
        layout="vertical"
        onFinish={handleLogin}
        autoComplete='off'
      >
        <Form.Item
          label="Enter OTP"
          name="otp"
          rules={[
            {
              required: true,
              message: 'OTP is required',
            },

          ]}
        >
          <Input className='fs-5' placeholder='------' style={{letterSpacing: 5}} />
        </Form.Item>
        <Button loading={btnLoading} block type="primary" className='px-5 fw-semibold' htmlType="submit" size="large">VERIFY & LOGIN</Button>
        <p className='mt-4 mb-0 text-center text-muted'>Go back to <Link to='/' className='text-primary'>Login</Link></p>
        </Form>
    </>
  )
}

export default OTPForm